import { Drawer } from "antd";
import { FormProvider, useForm } from "react-hook-form";
import { Row, Col, Button } from "reactstrap";
import FormSelect from "../../form-components/SelectComponent";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import { useEffect, useState, useCallback } from "react";
import misc from "../../../api/misc/dropDowns";

interface SelectOptions {
  label: string;
  value: string;
}

interface BOQSettingsDrawerProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  initialValues: any;
  siteId: string | null;
}

const BOQSettingsDrawer: React.FC<BOQSettingsDrawerProps> = ({
  open,
  onClose,
  onSubmit,
  initialValues,
  siteId,
}) => {
  const methods = useForm<any>({});
  const {
    handleSubmit,
    reset,
    watch,
  } = methods;

  const [usersOptions, setUsersOptions] = useState<SelectOptions[]>([]);
  const setAlertsWatch = watch("setAlerts");
  const hasAlerts =
    Array.isArray(setAlertsWatch) && setAlertsWatch.length > 0;

  useEffect(() => {
    if (open && initialValues) {
      reset(initialValues);
    }
  }, [open]);

  const fetchUsers = useCallback(async (siteIdParam: string) => {
    try {
      const data = await misc.fetchSiteUsers(siteIdParam);
      if (data) {
        setUsersOptions(
          data?.data
            ?.filter((item: any) => item.appUserId)
            .map((item: any) => ({
              label: item.userName,
              value: item.appUserId.toString(),
            })) || []
        );
      }
    } catch (error) {
      console.log(error);
      setUsersOptions([]);
    }
  }, []);

  useEffect(() => {
    if (hasAlerts && siteId) {
      fetchUsers(siteId);
    }
  }, [hasAlerts, siteId, fetchUsers]);

  const submitSettings = (values: any) => {
    // Resolve notify user names for preview display
    const notifyUserNames = Array.isArray(values.notifyUsers)
      ? values.notifyUsers.map((id: any) => {
          const user = usersOptions.find((u) => u.value === id?.toString());
          return user?.label || id;
        })
      : [];
    onSubmit({ ...values, notifyUserNames });
    onClose();
  };

  return (
    <Drawer
      title="BOQ Settings"
      placement="right"
      onClose={onClose}
      open={open}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitSettings)}>
          <Row>
            <Col lg="12">
              <FormSelect
                name="limitPostTargetConsumption"
                label="Limit Material Issue"
                defaultValue={initialValues.limitPostTargetConsumption}
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
                placeholder="-Select-"
              />
            </Col>
            <Col lg="12">
              <FormSelect
                name="limitPostTargetOrder"
                label="Limit PO?"
                defaultValue={initialValues.limitPostTargetOrder}
                options={[
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ]}
                placeholder="-Select-"
              />
            </Col>
            <Col lg="12">
              <FormMultiSelect
                name="setAlerts"
                label="Consumption Percentage"
                defaultValue={initialValues.setAlerts}
                options={Array.from({ length: 20 }, (_, i) => {
                  const value = (i + 1) * 5;
                  return { label: value.toString(), value: value.toString() };
                })}
                placeholder="-Select-"
              />
            </Col>
            {hasAlerts && (
              <Col lg="12">
                <FormMultiSelect
                  name="notifyUsers"
                  label="Notify Users"
                  required={true}
                  defaultValue={initialValues.notifyUsers}
                  options={usersOptions}
                  placeholder="Select Users to Notify"
                />
              </Col>
            )}
          </Row>
          <Button type="submit" color="primary" className="mt-3">
            Save
          </Button>
        </form>
      </FormProvider>
    </Drawer>
  );
};

export default BOQSettingsDrawer;
